import { motion } from "framer-motion";

const businessData = [
  {
    title: "FMCG Carrying & Forwarding (C&F) – DS Spiceco",
    desc: "Authorized Carrying & Forwarding partner handling warehousing, inventory control, and large-scale distribution of DS Spiceco FMCG products.",
    image: "/cf.jpeg",
  },
  {
    title: "Distributor – OPPO (Mobiles & Accessories)",
    desc: "Official distributor in selective areas of Ghaziabad supplying smartphones and accessories with strong dealer network management.",
    image:
      "https://image.oppo.com/content/dam/oppo/sg/mkt/flagship-store/nex-new.jpg",
  },
  {
    title: "Distributor – Cellcore Appliances",
    desc: "Distribution of refrigerators, air conditioners, and LED TVs ensuring smooth logistics and retail supply chain management.",
    image:
      "https://1repair.in/wp-content/uploads/2023/06/service-center-3.png",
  },
  {
    title: "Merchant Export & Import",
    desc: "Active participation in international trade with strong sourcing, documentation handling, and compliance management.",
    image:
      "https://media.philstar.com/photos/2019/03/19/bus4-export-file_2019-03-19_20-12-52.jpg",
  },
];

const Business = () => {
  return (
    <section className="bg-[#d9f0ea] py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
        
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2">
            Driving Distribution & Global Trade Excellence
          </h2>

          <p className="text-gray-700 mt-6 max-w-3xl mx-auto">
            We operate across FMCG, consumer electronics distribution,
            and international trade — delivering operational excellence,
            strong partnerships, and reliable supply chain management.
          </p>
        </motion.div>

        {/* Business Cards */}
        <div className="grid md:grid-cols-2 gap-12">
          {businessData.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.8 }}
              viewport={{ once: true }}
              className="bg-white rounded-3xl shadow-xl overflow-hidden group"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <motion.img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  whileHover={{ scale: 1.08 }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              </div>

              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                  {item.title}
                </h3>

                <p className="text-gray-600 leading-relaxed">
                  {item.desc}
                </p>

                <div className="mt-6 flex items-center gap-2 text-green-600 font-medium">
                  <span className="h-2 w-2 bg-green-600 rounded-full"></span>
                  <span>Trusted Operations</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Statement */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mt-20 text-center"
        >
          <h3 className="text-3xl font-bold text-gray-800">
            Building Strong Supply Chains with Integrity & Vision
          </h3>
          <p className="text-gray-700 mt-6 max-w-2xl mx-auto">
            Our focus remains on operational efficiency, strong partnerships,
            and consistent market expansion — ensuring sustainable business
            growth in domestic and international markets.
          </p>
        </motion.div>

      </div>
    </section>
  );
};

export default Business;